// extracted by mini-css-extract-plugin
export default {"reserveDivider":"__reserve_reserveDivider__vxg6m"};